if (!customElements.get('details-disclosure')) {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      this.content = this.mainDetailsToggle ? this.mainDetailsToggle.querySelector('summary')?.nextElementSibling : null;

      if (this.mainDetailsToggle) {
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
      }
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onToggle() {
      if (!this.animations && this.content) this.animations = this.content.getAnimations();

      if (this.mainDetailsToggle?.hasAttribute('open')) {
        this.animations?.forEach((animation) => animation.play());
      } else {
        this.animations?.forEach((animation) => animation.cancel());
      }
    }

    close() {
      this.mainDetailsToggle?.removeAttribute('open');
      this.mainDetailsToggle?.querySelector('summary')?.setAttribute('aria-expanded', false);
    }
  }

  window.DetailsDisclosure = DetailsDisclosure;
  customElements.define('details-disclosure', DetailsDisclosure);

  class HeaderMenu extends DetailsDisclosure {
    constructor() {
      super();
      this.header = document.querySelector('.header-wrapper');
    }

    onToggle() {
      if (!this.header) return;
      this.header.preventHide = this.mainDetailsToggle ? this.mainDetailsToggle.open : false;

      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  window.HeaderMenu = HeaderMenu;
  customElements.define('header-menu', HeaderMenu);
}
